import axios from 'axios'

const api = axios.create({
 //baseURL: 'https://api-sdc.herokuapp.com'
 //baseURL: 'http://localhost:5000'
 baseURL: 'https://api.ideiasadman.com.br'
})

export default api
